import { render, staticRenderFns } from "./EditSabbaticalRequestModal.vue?vue&type=template&id=8bcf080c&scoped=true&"
import script from "./EditSabbaticalRequestModal.vue?vue&type=script&lang=js&"
export * from "./EditSabbaticalRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./EditSabbaticalRequestModal.vue?vue&type=style&index=0&id=8bcf080c&lang=scss&scoped=true&"
import style1 from "./EditSabbaticalRequestModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcf080c",
  null
  
)

export default component.exports